import { ModalPragmaForm } from '@/components/modal/modal-state-variants/modal-pragma-form';
import { ModalPromotionCodeError } from '@/components/modal/modal-state-variants/modal-promotion-code-error';

import { ModalLoanActionCard } from './modal-state-variants/modal-loan-action-card';
import { ModalLoanAgreements } from './modal-state-variants/modal-loan-agreements';
import { ModalExample } from './modal-state-variants/modal-example';
import { ModalLoanRecipentDetails } from './modal-state-variants/modal-loan-recipent-details';
import { ModalLoanCancel } from './modal-state-variants/modal-loan-cancel';
import { ModalRepresentativeAddressData } from './modal-state-variants/modal-representative-address-data';
import { ModalLiberisAgreementsAdditionalData } from './modal-state-variants/modal-liberis-agreements-additional-data';
import { ModalLiberisMultiproviderLoanStage } from './modal-state-variants/modal-liberis-multiprovider-loan-stage';
import { ModalNoAvailableOffers } from './modal-state-variants/modal-no-available-offers';
import type { ModalState, ModalStateUnion } from './modal.store';
import { MODAL_STATE, useModalStore } from './modal.store';

export type ModalProps = ModalState & { modalState: ModalStateUnion };

const getModal = (modalProps: ModalProps) => {
  switch (modalProps.modalState) {
    case MODAL_STATE.EXAMPLE_MODAL:
      return <ModalExample {...modalProps} />;
    case MODAL_STATE.LOAN_ACTION_CARD_MODAL:
      return <ModalLoanActionCard {...modalProps} />;
    case MODAL_STATE.LOAN_AGREEMENTS:
      return <ModalLoanAgreements {...modalProps} />;
    case MODAL_STATE.LOAN_RECIPIENT_DETAILS:
      return <ModalLoanRecipentDetails {...modalProps} />;
    case MODAL_STATE.LOAN_CANCEL:
      return <ModalLoanCancel {...modalProps} />;
    case MODAL_STATE.REPRESENTATIVE_ADDRESS_DATA:
      return <ModalRepresentativeAddressData {...modalProps} />;
    case MODAL_STATE.LIBERIS_AGREEMENTS_ADDITIONAL_INFO:
      return <ModalLiberisAgreementsAdditionalData {...modalProps} />;
    case MODAL_STATE.LIBERIS_MULTIPROVIDER_LOAN_STAGE:
      return <ModalLiberisMultiproviderLoanStage {...modalProps} />;
    case MODAL_STATE.NO_AVAILABLE_OFFERS:
      return <ModalNoAvailableOffers {...modalProps} />;
    case MODAL_STATE.PRAGMA_FORM:
      return <ModalPragmaForm {...modalProps} />;
    case MODAL_STATE.PROMOTION_CODE_ERROR:
      return <ModalPromotionCodeError {...modalProps} />;
    default:
      return null;
  }
};

export function DisplayModal() {
  const modalStore = useModalStore();
  const { modalState } = modalStore;
  if (!modalState) return null;

  return getModal({ ...modalStore, modalState });
}
